// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'inputRef' implicitly has an 'any' type.
export function FileUploadInput({ inputRef, onChange }) {
  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'event' implicitly has an 'any' type.
  const handleOnChange = (event) => {
    onChange(event.target.files[0]);
    inputRef.current.value = "";
  };

  return (
    <input
      aria-label="Upload reference time card"
      type="file"
      onChange={handleOnChange}
      ref={inputRef}
      accept="application/pdf, image/*"
      style={{ display: "none" }}
    />
  );
}
